import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useModal } from '@/shared/hooks';
import { Icon } from '@/shared/ui';

import styles from './modalWrapper.module.scss';
import { MODAL_VARIANTS } from '../../config/constants';
import { useModalStore } from '../../model/store';

interface ModalWrapperProps {
  children: ReactNode;
  variant?: string;
}

const ModalWrapper: FC<ModalWrapperProps> = (props) => {
  const { children, variant = MODAL_VARIANTS.confirm } = props;
  const { modal, closeModal } = useModalStore();

  useModal({
    isOpen: !!modal,
    onClose: closeModal,
  });

  if (!modal) return null;

  const modalContent = (
    <div
      aria-modal="true"
      className={classNames(styles.modal, styles[`modal--${variant}`])}
      role="dialog"
    >
      <div className={classNames(styles.modal__content)} tabIndex={-1}>
        <div className={styles.modal__body}>
          {modal !== MODAL_VARIANTS.confirm && (
            <div className={styles.modal__top}>
              <button className={styles.modal__button} onClick={closeModal}>
                <Icon name="crossBig" />
              </button>
            </div>
          )}
          {children}
        </div>
      </div>
      <div className={styles.modal__overlay} onClick={closeModal} />
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ModalWrapper;
